<script setup lang="ts">
import { useClassStore } from '../../stores';
import { ClassViewMode } from '../../types/class';
import Session from '../../components/Session/Session.vue';
import StudentList from '../../components/Class/StudentList.vue';
import ClassDetails from '../../components/Class/ClassDetails.vue';
import ClassSchedule from '../../components/Class/ClassSchedule.vue';
import ClassEnding from '../../components/Notification/ClassEnding.vue';

const classStore = useClassStore()

</script>

<template>
    <ClassSchedule v-if="!classStore.selectedClassDetails" />
    <div v-else class="h-full flex-col flex flex-1 gap-3 rounded-lg bg-neutral-100 relative overflow-auto" :class="{ 'p-3': classStore.viewMode === ClassViewMode.management }">
        <template v-if="classStore.viewMode === ClassViewMode.management">
            <ClassDetails />
            <StudentList />
        </template>
        <template v-if="classStore.viewMode === ClassViewMode.teaching">
            <Session />
        </template>
    </div>
    <ClassEnding />
</template>